import Axios from 'axios';
import { buildWebStorage, setupCache } from 'axios-cache-interceptor';
import { AXIOS_CACHE_TTL } from 'config/constants';

const axiosInstance = Axios.create();

export const axios = setupCache(axiosInstance, {
  ttl:
    Number.parseInt(process.env.REACT_APP_AXIOS_CACHE_TTL!) || AXIOS_CACHE_TTL, //1 second
  storage: buildWebStorage(sessionStorage, 'axios-cache'),
  cacheTakeover: false,
});
